import { api, flashMessage, formatter } from '../util';

/**
 * Plugin for creating additional fields for deadlines.
 */
(function ($) {
	$(document).on('change', '.deadline-change-checkbox', function (e) {
		let checked = $(this).prop('checked');
		let deadlineRow = $(this).parents('.deadline-row');

		if (checked) {
			deadlineRow.find('.deadline-document-data').removeClass('hidden');
		} else {
			deadlineRow.find('.deadline-document-data').addClass('hidden');
		}
	});

	$(document).on('click', '.add-deadline', function (e) {
		let form = $(this).parents('.save-deadlines');
		let deadlineTemplate = form.find('.new-deadline-template');
		let newDeadline = deadlineTemplate.clone().removeClass('new-deadline-template');
		deadlineTemplate.before(newDeadline);
	});

	function validateDeadline(deadlineData) {
		let errors = [];
		let isoDateFormat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;

		if (deadlineData.deliveryDays.length === 0) {
			errors.push('Vyplňte prosím délku doručení lhůty.');
		}

		if (deadlineData.legalForceDays.length === 0) {
			errors.push('Vyplňte prosím délku trvání lhůty.');
		}

		if (deadlineData.dateStart.length === 0) {
			errors.push('Vyplňte prosím začátek lhůty.');
		}

		if (deadlineData.dateEnd.length === 0) {
			errors.push('Vyplňte prosím konec lhůty.');
		}

		if (deadlineData.dateStart.match(isoDateFormat) === null) {
			errors.push('Datum začátku nemá správný formát');
		}

		if (deadlineData.dateEnd.match(isoDateFormat) === null) {
			errors.push('Datum konce nemá správný formát');
		}

		let { dateInvalid } = deadlineData;
		if (dateInvalid !== undefined && dateInvalid.length > 0 && dateInvalid.match(isoDateFormat) === null) {
			errors.push('Datum zneplatnění nemá správný formát');
		}

		if (new Date(deadlineData.dateStart) > new Date(deadlineData.dateEnd)) {
			errors.push('Datum začátku musí být před koncem lhůty');
		}

		return errors;
	}

	$(document).on('submit', '.save-deadlines', function (e) {
		e.stopImmediatePropagation();

		let form = $(this);
		let procedureId = form.find('[name=procedureId]').val();
		let documentId = form.find('[name=documentId]').val();
		let url = `/admin/procedures/${encodeURIComponent(procedureId)}/documents/${encodeURIComponent(
			documentId
		)}/deadlines`;

		let data = [];
		let errors = [];

		form.find('[name=id]:checked').each(function () {
			let deadlineId = $(this).val();
			let isChange = form.find(`[name="change[${deadlineId}]"]:checked`).length !== 0;

			let deliveryDays = form.find(`[name="deliveryDays[${deadlineId}]"]`).val();
			let legalForceDays = form.find(`[name="legalForceDays[${deadlineId}]"]`).val();
			let dateStart = form.find(`[name="dateStart[${deadlineId}]"]`).val();
			let dateEnd = form.find(`[name="dateEnd[${deadlineId}]"]`).val();
			let dateInvalid = form.find(`[name="dateInvalid[${deadlineId}]"]`).val();

			if (isChange === false) {
				deliveryDays = '0';
				legalForceDays = '0';
				dateStart = '2000-01-01'; // dummy value because of not null :/
				dateEnd = '2000-01-02'; // dummy value because of not null :/
			}

			let deadlineData = {
				deliveryDays: deliveryDays,
				legalForceDays: legalForceDays,
				dateStart: dateStart,
				dateEnd: dateEnd,
				dateInvalid: dateInvalid,
			};

			let deadlineErrors = validateDeadline(deadlineData);
			for (const deadlineError of deadlineErrors) {
				errors.push(deadlineError);
			}

			data.push({
				id: deadlineId,
				change: isChange,
				typeId: form.find(`[name="typeId[${deadlineId}]"]`).val(),
				deliveryDays: deliveryDays,
				legalForceDays: legalForceDays,
				dateStart: dateStart,
				dateEnd: dateEnd,
				dateInvalid: dateInvalid,
			});
		});

		form.find('[name="typeId[]"]').each(function () {
			let row = $(this).parents('.form-row');

			let newDeadlineData = {
				typeId: row.find('[name="typeId[]"]').val(),
				deliveryDays: row.find('[name="deliveryDays[]"]').val(),
				legalForceDays: row.find('[name="legalForceDays[]"]').val(),
				dateStart: row.find('[name="dateStart[]"]').val(),
				dateEnd: row.find('[name="dateEnd[]"]').val(),
			};

			if (newDeadlineData.typeId.length === 0) {
				return;
			}

			let deadlineErrors = validateDeadline(newDeadlineData);
			for (const deadlineError of deadlineErrors) {
				errors.push(deadlineError);
			}

			data.push({
				id: null,
				change: true,
				typeId: row.find('[name="typeId[]"]').val(),
				deliveryDays: row.find('[name="deliveryDays[]"]').val(),
				legalForceDays: row.find('[name="legalForceDays[]"]').val(),
				dateStart: row.find('[name="dateStart[]"]').val(),
				dateEnd: row.find('[name="dateEnd[]"]').val(),
				dateInvalid: null,
			});
		});

		if (errors.length > 0) {
			let message = errors.join('\n');
			// eslint-disable-next-line no-alert
			alert(message);
			return false;
		}

		api
			.post(url, data)
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			.done(function (response) {})
			.done(function (response) {
				flashMessage.show('success', 'Lhůty uloženy. Aktualizuji stránku...');
				location.reload();
			})
			.fail(function (response) {
				if (
					response.responseJSON != null &&
					response.responseJSON.errors != null &&
					response.responseJSON.errors[0].code === 'procedure-deadline-duplicate'
				) {
					flashMessage.show('error', 'Tato lhůta už je uložená - pokud ji nevidíte, zkuste znovu načíst stránku');
				} else {
					flashMessage.show('error', 'Něco se polámalo :(');
				}
			});

		return false;
	});
})(jQuery);

/**
 * Autocomplete dates for deadline start / end
 */
(function ($) {
	/****************** Marking deadlines as finished ****************/
	$(document).on('click', '.btn-procedure-document-deadlines-checked', function () {
		let parentElement = $(this).parents('.mark-deadlines-checked-container');
		let url = $(this).attr('href');
		api.post(url).done(function (response) {
			flashMessage.show('success', 'Lhůty zkontrolovány / dokončeny');
			parentElement.remove();
		});

		return false;
	});

	$(document).on(
		'change',
		'.save-deadlines input[name="deliveryDays[]"], .save-deadlines input[name="legalForceDays[]"]',
		function () {
			let row = $(this).parents('.form-row');
			let documentContainer = row.parents('.document-container');
			let deliveryDays = parseInt(row.find('input[name="deliveryDays[]"]').val());
			let legalForceDays = parseInt(row.find('input[name="legalForceDays[]"]').val());

			if (isNaN(deliveryDays) || isNaN(legalForceDays)) {
				return;
			}

			let dateStartInput = row.find('input[name="dateStart[]"]');
			let dateEndInput = row.find('input[name="dateEnd[]"]');

			let dateStart;
			let newDateStart;

			if (hasProcedureStartLabel(documentContainer)) {
				let procedureStartString = documentContainer.find('input[name=procedureStart]').val();
				dateStart = new Date(procedureStartString);
				newDateStart = dateStart;
			} else {
				let publishedString = documentContainer.find('input[name=published]').val();
				dateStart = new Date(publishedString);
				newDateStart = addDays(dateStart, deliveryDays);
			}

			let newDateEnd = addDays(newDateStart, legalForceDays);

			dateStartInput.val(formatter.formatIsoDate(newDateStart));
			dateEndInput.val(formatter.formatIsoDate(newDateEnd));
		}
	);

	/**
	 * Deadlines are :garbage_fire: and deadlines that are "starting" Procedure need to be handled a little bit differently
	 * https://cogvio.slack.com/archives/CBNKX39QA/p1602153000002700
	 **/
	function hasProcedureStartLabel(documentContainer) {
		let labels = [];

		documentContainer.find('.procedure-document-label-item').each(function () {
			labels.push($(this).text());
		});

		for (let i = 0; i < window.deadlineMappings.length; i++) {
			let mapping = window.deadlineMappings[i];

			if (mapping.start === 'PROCEDURE_STARTED') {
				return labels.includes(mapping.labelFullName);
			}
		}

		return false;
	}

	function addDays(date, days) {
		let result = new Date(date);
		result.setDate(result.getDate() + days);
		return result;
	}
})(jQuery);

/**
 * Prefill deadlines from labels
 */
(function ($) {
	$(document).on('click', '.btn-procedure-document-label-checked', function (e) {
		let documentContainer = $(this).parents('.document-container');

		documentContainer.find('.procedure-document-label-item').each(function () {
			let labelFullName = $(this).text();

			for (let i = 0; i < window.deadlineMappings.length; i++) {
				let mapping = window.deadlineMappings[i];

				if (mapping.labelFullName !== labelFullName) {
					continue;
				}

				let form = documentContainer.find('.save-deadlines');
				let deadlineTemplate = form.find('.new-deadline-template');
				let newDeadline = deadlineTemplate.clone().removeClass('new-deadline-template');

				newDeadline.find('select[name="typeId[]"]').val(mapping.deadlineTypeId);
				newDeadline.find('input[name="legalForceDays[]"]').val(mapping.legalForceDays);
				newDeadline.find('input[name="deliveryDays[]"]').val(mapping.deliveryDays);

				deadlineTemplate.before(newDeadline);
				newDeadline.find('input[name="deliveryDays[]"]').change(); // we want trigger change to fill dates
			}
		});
	});
})(jQuery);
